import { mapGetters } from 'vuex';
import isEqual from 'lodash-es/isEqual';
import debounce from 'lodash-es/debounce';
import { dataGet } from '@fps/vue-toolkit/dist/util';
import mutations from '@/store/filters/filters.mutationlist';
import limitReplacers from '@/filter/limit-replacers';

export default {
  data() {
    return {
      values: {},
      setFieldValueDebounced: null,
    };
  },
  computed: {
    ...mapGetters([
      'attributeTypes',
    ]),
  },
  methods: {
    getFieldValue(atType) {
      return dataGet(`filters.dynamic._${atType.id}.value`, this.$store.state);
    },
    setFieldValue(value, type) {
      return new Promise((resolve => this.setFieldValueDebounced(value, type, resolve)));
    },
    _setFieldValue(value, type) {
      if (!value) {
        switch (type.type) {
          case 'range':
            // if no value is to be set,  push either what was before or the existing limits
            // ( why? because mobile filters wont know to filter out
            // the current filter unless its in the state )
            // eslint-disable-next-line no-param-reassign
            value = this.getFieldValue(type) || [limitReplacers(type.type_data_parsed.min, 'number'), limitReplacers(type.type_data_parsed.max, 'number')];
            break;
          default:
        }
      }
      if (!isEqual(value, this.getFieldValue(type))) {
        this.$store.commit(mutations.FILTER_SET, {
          key: 'dynamic',
          value: {
            ...dataGet('filters.dynamic', this.$store.state),
            [`_${type.id}`]: { type, value },
          },
        });
      }
    },
  },
  mounted() {
    this.setFieldValueDebounced = debounce((value, type, resolve) => {
      // eslint-disable-next-line no-underscore-dangle
      this._setFieldValue(value, type);

      resolve();
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/filters/dynamic-fields.js